module.exports = __webpack_public_path__ + "img/unique-1-xl.5da3c27.webp";